import Vue from 'vue'

/**
 * @author Mariela T. TL <mariela.temozihui@jbge.com.mx>
 *
 *
 * Send approved packege
 *
 * @return {Object}
 */

const sendApprovedPackage = (payload) =>
  Vue.$http.post(`extranet/package/client-approval/`, payload)
    .then()
    .catch(err => { throw err })

export default sendApprovedPackage


// WEBPACK FOOTER //
// ./src/services/extranet/sendApprovedPackage.js